export const fmtTRY = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(n ?? 0);

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("tr-TR", { day: "2-digit", month: "long", year: "numeric" }) : "";

export const effectivePrice = (p) => p.discount_price ?? p.price;

export const discountPercent = (p) =>
  p.discount_price ? Math.round((1 - p.discount_price / p.price) * 100) : 0;

const QTY4_UNITS = ["kg", "kilogram", "l", "lt", "litre", "m", "metre"];
export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const fmtQty4 = (n, unit = "") => {
  const v = Number(n ?? 0);
  const isQ4 = QTY4_UNITS.includes(String(unit).toLowerCase());
  if (isQ4) return v.toLocaleString("tr-TR", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
  if (Number.isInteger(v)) return v.toLocaleString("tr-TR", { maximumFractionDigits: 0 });
  return v.toLocaleString("tr-TR", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
};
